<!-- A refetch keeps the previous timeline under the spinner, so the tile doesn't collapse while it loads -->
<div class="relative shrink-0" [class.min-h-32]="isLoading()">
  <!-- A block svg, since an inline one adds a line's descender under it - enough to push a timeline that
     exactly fills the dashboard tile past its height -->
  <div #timelineContainer class="milestone-timeline-container [&>svg]:block"></div>

  @if (isLoading()) {
    <!-- Clipped, since the spinner spins its square box: at its diagonal it pokes out of the 128px placeholder
       and keeps flicking the dashboard tile's scrollbar on and off -->
    <div
      class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden bg-surface-bg-dim-white"
      data-testid="milestone-timeline-loading"
    >
      <p-progress-spinner />
    </div>
  }
</div>

<div
  #timelineTooltip
  class="pointer-events-none absolute"
  [style.left.px]="tooltipPlacement()?.left ?? 0"
  [style.top.px]="tooltipPlacement()?.top ?? 0"
  [style.width.px]="tooltipPlacement()?.width ?? 0"
  [style.height.px]="tooltipPlacement()?.height ?? 0"
  [pTooltip]="tooltipText()"
  tooltipPosition="top"
  aria-hidden="true"
></div>

@if (fullscreen() && selectedMilestoneName()) {
  <div class="flex shrink-0 items-center gap-4">
    <p-breadcrumb [model]="breadcrumbItems()" data-testid="milestone-drilldown-breadcrumb" />
    @if (areTasksHiddenByVisibility()) {
      <p-message
        *appTranslate="let t"
        severity="info"
        variant="simple"
        size="small"
        icon="pi pi-info-circle"
        [text]="t('milestones.candidates.tasksHiddenByVisibility')"
        data-testid="milestone-drilldown-hidden-tasks-info"
      />
    }
  </div>

  <!-- Either table scrolls itself (scrollHeight="flex") in whatever height the dialog leaves under the
     timeline. That needs a definite height all the way down to PrimeNG's table, hence the inner hosts. -->
  @if (selectedCandidate(); as candidate) {
    <new-ui-flat-task-table
      class="block min-h-0 flex-1 [&_new-ui-table]:block [&_new-ui-table]:h-full [&_p-table]:block [&_p-table]:h-full"
      [items]="selectedCandidateTasks() ?? []"
      [isRowSelectable]="false"
      [hiddenColumns]="hiddenTaskColumns"
      [tableOperations]="taskOperations"
    />
  } @else {
    <new-ui-table
      #candidateTable
      class="block min-h-0 flex-1 [&_p-table]:block [&_p-table]:h-full"
      [columns]="candidateColumns"
      [items]="visibleMilestoneCandidates()"
      [numberOfRows]="candidateRowsPerPage()"
      [scrollable]="true"
      scrollHeight="flex"
      [showSearch]="false"
      selectionMode="single"
      (selectionChange)="onCandidateSelected($event)"
      data-testid="milestone-candidates-table"
    />
  }
}

@if (openedTaskAction(); as opened) {
  <new-ui-process-task-action-drawer
    [task]="opened.item.task"
    [action]="opened.action"
    [process]="opened.item.process"
    [processLanguage]="processLanguage"
    [siblingTasks]="openedTaskSiblings()"
    (changed)="onTaskChanged()"
    (dismissed)="onTaskChanged()"
    (closed)="openedTaskAction.set(null)"
  />
}
